import { ROLE_GET, ROLE_DELETE, ROLE_GET_ALL } from '../actions/roles'
import apiCall from './call'

const model = 'roles'

const state = {
  //
}

const getters = {
  //
}

const actions = {
  [ROLE_GET]: ({ commit, dispatch }, userId) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/' + userId })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ROLE_GET_ALL]: ({ commit, dispatch }, args) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model, ...args })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ROLE_DELETE]: ({ commit, dispatch }, userId) => {
    let users = { ids: [userId] }
    return new Promise((resolve, reject) => {
      apiCall({ url: model, data: users, method: 'DELETE' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

const mutations = {
  //
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/roles.js